import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing a table view.
 * @extends JetView
 */
export default class tableView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                { id: 'Id', header: '', hidden: true }, // Hidden column for ID
                                {
                                    id: 'rating', // Column for rating
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon
                                    },
                                },
                                {
                                    id: 'Slug', // Column for Slug
                                    header: _('Slug'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Description', // Column for Description
                                    header: _('Descripción'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Icon', // Column for Icon
                                    header: _('Icono'), // Localized header
                                    width: 50,
                                    height: 25,
                                    tooltip: _('Icono'), // Tooltip for the icon
                                    template: function (obj) {
                                        if (obj.Icon != null) {
                                            return "<span class='webix_icon wxi-close details'></span>"; // Details icon if Icon exists
                                        }
                                        return '';
                                    },
                                },
                                {
                                    id: 'Order', // Column for Order
                                    header: _('Orden'), // Localized header
                                    width: 80,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column for State
                                    header: _('Estado'), // Localized header
                                    width: 150,
                                    options: [
                                        // Options for State dropdown
                                        { id: '0', value: _('Activa') },
                                        { id: '1', value: _('Inactiva') },
                                    ],
                                },
                                {
                                    id: 'Type', // Column for Type
                                    header: _('Tipo'), // Localized header
                                    width: 150,
                                    options: [
                                        // Options for Type dropdown
                                        { id: '0', value: _('Casino') },
                                        { id: '1', value: _('Live Casino') },
                                        { id: '2', value: _('Virtuales') },
                                        { id: '3', value: _('Mini Games') },
                                        { id: '4', value: _('Payment') },
                                        { id: '5', value: _('Bingo') },
                                    ],
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Event handler for edit icon click
                                    vthis.app.callEvent('openEdit', [{}]); // Trigger openEdit event
                                },
                                details: function (euv, id) {
                                    // Event handler for details icon click
                                    var item = this.getItem(id); // Get the clicked item
                                    console.log(item.Icon); // Log the Icon value
                                    webix
                                        .ui({
                                            view: 'window', // Create a window for details
                                            move: true,
                                            width: 500,
                                            height: 500,
                                            margin: 10,
                                            fullscreen: screen.width < 500 ? true : false, // Fullscreen if screen width is less than 500
                                            head: {
                                                view: 'toolbar',
                                                cols: [
                                                    {
                                                        view: 'label',
                                                        label: _('Ícono'), // Localized label
                                                        align: 'center',
                                                    },
                                                    {
                                                        view: 'icon',
                                                        icon: 'wxi-close',
                                                        click: function () {
                                                            this.getTopParentView().hide(); // Hide the window on close
                                                        },
                                                    },
                                                ],
                                            },
                                            modal: true, // Modal window
                                            position: 'center',
                                            body: {
                                                view: 'scrollview', // Scrollable body
                                                scroll: 'xy',
                                                body: {
                                                    cols: [
                                                        {
                                                            template: function (obj) {
                                                                return (
                                                                    "<div class='my-messages'>" +
                                                                    item.Icon + // Display the Icon
                                                                    '</div>'
                                                                );
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        })
                                        .show(); // Show the window
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead setting
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch setting
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        grid = $$('datatable'); // Get the DataTable instance
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'PartnersCategories/GetPartnersCategories'; // API URL for fetching categories
        var filter = ''; // Filter string for API requests
        this.on(this.app, 'partnerCategories:filter', (filterData) => {
            // Event listener for filtering categories
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            filter = string1; // Update filter string
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=1000' + string1); // Load data with filters
        });
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const partners = profile.Partners; // Get partners from profile
        function filter_partners(partners) {
            return partners.id == id_partner; // Filter function for partners
        }
        var partner = partners.filter(filter_partners); // Get the specific partner
        var listCountries = partner[0].Countries.filter(
            // Filter countries for the partner
            (item) => item.value != 'Todos' && item.value != 'Default',
        );
        var popupAdd = webix.ui({
            // Create a popup for adding categories
            view: 'window',
            fullscreen: screen.width < 500 ? true : false, // Fullscreen if screen width is less than 500
            width: 700,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Agregar Categoría'), // Localized label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on close
                        },
                    },
                ],
            },
            position: 'center',
            modal: true, // Modal window
            body: {
                view: 'form', // Form for adding category
                id: 'addform', // ID for the form
                elements: [
                    {
                        rows: [
                            {
                                cols: [
                                    {
                                        margin: 10,
                                        rows: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Slug'), // Localized label
                                                name: 'Slug',
                                                required: true, // Required field
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Estado'), // Localized label
                                                name: 'State',
                                                options: [
                                                    // Options for State dropdown
                                                    {
                                                        id: '0',
                                                        value: _('Activa'),
                                                    },
                                                    {
                                                        id: '1',
                                                        value: _('Inactiva'),
                                                    },
                                                ],
                                                required: true, // Required field
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('País'), // Localized label
                                                name: 'Country',
                                                options: listCountries, // Country options
                                                required: true, // Required field
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        rows: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Descripción'), // Localized label
                                                name: 'Description',
                                                required: true, // Required field
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Orden'), // Localized label
                                                name: 'Order',
                                                type: 'number', // Number input
                                                required: true, // Required field
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Tipo'), // Localized label
                                                name: 'Type',
                                                options: [
                                                    // Options for Type dropdown
                                                    {
                                                        id: '0',
                                                        value: _('Casino'),
                                                    },
                                                    {
                                                        id: '1',
                                                        value: _('Live Casino'),
                                                    },
                                                    {
                                                        id: '2',
                                                        value: _('Virtuales'),
                                                    },
                                                    {
                                                        id: '3',
                                                        value: _('Mini Games'),
                                                    },
                                                    {
                                                        id: '4',
                                                        value: _('Payment'),
                                                    },
                                                    {
                                                        id: '5',
                                                        value: _('Bingos'),
                                                    },
                                                ],
                                                required: true, // Required field
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                height: 250,
                                cols: [
                                    {
                                        margin: 10,
                                        rows: [
                                            {
                                                view: 'textarea',
                                                labelPosition: 'top',
                                                label: _('SVG Icono'), // Localized label
                                                heigth: 50,
                                                name: 'Icon',
                                                required: true, // Required field
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Localized label
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the window on cancel
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Localized label
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    values.Partner = id_partner; // Add partner ID to values
                                    const vthis = this; // Reference to the current button
                                    if ($$('addform').validate()) {
                                        // Validate form
                                        const json = JSON.stringify(values, (key, val) => {
                                            if (typeof val === 'string') {
                                                return val
                                                    .replace(/ñ/g, '&#241;')
                                                    .replace(/Ñ/g, '&#209;')
                                                    .replace(/á/g, '&#225;')
                                                    .replace(/Á/g, '&#193;')
                                                    .replace(/é/g, '&#233;')
                                                    .replace(/É/g, '&#201;')
                                                    .replace(/í/g, '&#237;')
                                                    .replace(/Í/g, '&#205;')
                                                    .replace(/ó/g, '&#243;')
                                                    .replace(/Ó/g, '&#211;')
                                                    .replace(/ú/g, '&#250;')
                                                    .replace(/Ú/g, '&#218;');
                                            }
                                            return val; // Return value
                                        });
                                        var objJsonB64 = btoa(
                                            unescape(encodeURIComponent(json)), // Encode JSON to Base64
                                        );
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnersCategories/CreatePartnersCategories', // API URL for creating categories
                                                objJsonB64, // Base64 encoded JSON
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message('Error! '); // Show error message
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message('Error: ' + text.AlertMessage); // Show error message
                                                        } else {
                                                            webix.message('Categoría creada satisfactoriamente'); // Success message
                                                            grid.clearAll(); // Clear grid data
                                                            grid.load(url + '?start=0&count=1000' + filter); // Reload grid data
                                                            $$('addform').setValues(
                                                                $$('addform').getCleanValues(), // Reset form values
                                                            );
                                                            vthis.getTopParentView().hide(); // Hide the window
                                                        }
                                                    },
                                                },
                                            );
                                        this.getTopParentView().hide(); // Hide the window
                                    } else {
                                        webix.message({
                                            title: _('¡Error!'), // Localized title
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Localized error message
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
            },
        });
        var popupEdit = webix.ui({
            // Create a popup for editing categories
            view: 'window',
            width: 700,
            fullscreen: screen.width < 500 ? true : false, // Fullscreen if screen width is less than 500
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar') }, // Localized label
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on close
                        },
                    },
                ],
            },
            position: 'center',
            modal: true, // Modal window
            body: {
                view: 'form', // Form for editing category
                id: 'editform', // ID for the form
                elements: [
                    {
                        rows: [
                            {
                                cols: [
                                    {
                                        margin: 10,
                                        rows: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Id'), // Localized label
                                                name: 'Id',
                                                hidden: true, // Hidden field for ID
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Slug'), // Localized label
                                                name: 'Slug',
                                                readonly: false, // Editable field
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Estado'), // Localized label
                                                name: 'State',
                                                options: [
                                                    // Options for State dropdown
                                                    {
                                                        id: '0',
                                                        value: _('Activa'),
                                                    },
                                                    {
                                                        id: '1',
                                                        value: _('Inactiva'),
                                                    },
                                                ],
                                                readonly: false, // Editable field
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('País'), // Localized label
                                                name: 'Country',
                                                options: listCountries, // Country options
                                                readonly: false, // Editable field
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        rows: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Descripción'), // Localized label
                                                name: 'Description',
                                                readonly: false, // Editable field
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Orden'), // Localized label
                                                name: 'Order',
                                                type: 'number', // Number input
                                                readonly: false, // Editable field
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Tipo'), // Localized label
                                                name: 'Type',
                                                options: [
                                                    // Options for Type dropdown
                                                    {
                                                        id: '0',
                                                        value: _('Casino'),
                                                    },
                                                    {
                                                        id: '1',
                                                        value: _('Live Casino'),
                                                    },
                                                    {
                                                        id: '2',
                                                        value: _('Virtuales'),
                                                    },
                                                    {
                                                        id: '3',
                                                        value: _('Mini Games'),
                                                    },
                                                    {
                                                        id: '4',
                                                        value: _('Payment'),
                                                    },
                                                    {
                                                        id: '5',
                                                        value: _('Bingos'),
                                                    },
                                                ],
                                                readonly: false, // Editable field
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                height: 250,
                                cols: [
                                    {
                                        margin: 10,
                                        rows: [
                                            {
                                                view: 'textarea',
                                                labelPosition: 'top',
                                                label: _('SVG Icono'), // Localized label
                                                heigth: 50,
                                                name: 'Icon',
                                                readonly: false, // Editable field
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Localized label
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the window on cancel
                                    $$('editform').setValues(
                                        $$('editform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Localized label
                                click: function ($e) {
                                    var values = $$('editform').getValues(); // Get form values
                                    if ($$('editform').validate()) {
                                        // Validate form
                                        const json = JSON.stringify(values, (key, val) => {
                                            if (typeof val === 'string') {
                                                return val
                                                    .replace(/ñ/g, '&#241;')
                                                    .replace(/Ñ/g, '&#209;')
                                                    .replace(/á/g, '&#225;')
                                                    .replace(/Á/g, '&#193;')
                                                    .replace(/é/g, '&#233;')
                                                    .replace(/É/g, '&#201;')
                                                    .replace(/í/g, '&#237;')
                                                    .replace(/Í/g, '&#205;')
                                                    .replace(/ó/g, '&#243;')
                                                    .replace(/Ó/g, '&#211;')
                                                    .replace(/ú/g, '&#250;')
                                                    .replace(/Ú/g, '&#218;');
                                            }
                                            return val; // Return value
                                        });
                                        var objJsonB64 = btoa(
                                            unescape(encodeURIComponent(json)), // Encode JSON to Base64
                                        );
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnersCategories/UpdatePartnersCategories', // API URL for updating categories
                                                objJsonB64, // Base64 encoded JSON
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message('Error! '); // Show error message
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message('Error: ' + text.AlertMessage); // Show error message
                                                        } else {
                                                            webix.message('Categoría editada satisfactoriamente'); // Success message
                                                            grid.clearAll(); // Clear grid data
                                                            grid.load(
                                                                url + '?start=0&count=1000' + filter, // Reload grid data
                                                            );
                                                            this.getTopParentView().hide(); // Hide the window
                                                            $$('editform').setValues(
                                                                $$('editform').getCleanValues(), // Reset form values
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        this.getTopParentView().hide(); // Hide the window
                                    } else {
                                        webix.message({
                                            title: _('¡Error!'), // Localized title
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Localized error message
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
            },
        });
        $$('editform').bind($$('datatable')); // Bind edit form to the DataTable
        this.on(this.app, 'openEdit', (item) => {
            // Event listener for opening edit form
            $$('editform').setValues($$('editform').getCleanValues()); // Reset form values
            popupEdit.show(); // Show the edit popup
        });
        this.on(this.app, 'add:button', (item) => {
            // Event listener for adding a category
            popupAdd.show(); // Show the add popup
        });
    }
}

// FILE DOCUMENTED
